import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Role } from '../shared/model/Role.model';
import { FilterRequest } from '../shared/model/filter-request.model';
import { BossDependence } from '../shared/model/boss-dependence.model';
import { FacultyService } from '../../programs/shared/faculty.service';
import { Faculty } from '../../programs/shared/faculty.model';
import { ProgramService } from '../../programs/shared/program.service';
import { Program } from '../../programs/shared/program.model';
import { UtilityService } from 'src/app/core/shared/utility.service';


@Component({
  selector: 'app-search-fields',
  templateUrl: './search-fields.component.html',
  styleUrls: ['./search-fields.component.scss']
})
export class SearchFieldsComponent implements OnInit {

  selectedFaculty: String;
  selectedProgram: String;
  selectedType: String = 'MATERIA REGULAR';
  selectedCedula: String = '';
  @Input() roles: Role[] = [];
  @Input() bossDeependence: BossDependence;
  @Input() viceFaculty: any;

  @Output()
  sendSearchRequest: EventEmitter<any> = new EventEmitter();

  faculties: Faculty[] = [];
  programs: Program[] = [];
  @Input() currentRol: Role;
  @Input() typeValidation: number;
  enabledFaculty = true;
  enabledType = false;
  enabledSpinner = false;
  enabledMateriaRegular = true;
  filterRequest: FilterRequest;


  constructor(private facultyService: FacultyService, private programService: ProgramService, private utilityService: UtilityService) { }

  ngOnInit() {
    this.getFacultyList();
  }

  onSelectFaculty(faculty) {
    if (faculty) {
      this.enabledSpinner = true;
      this.getProgramList(faculty);
    } else {
      this.selectedProgram = '';
    }

  }

  sendSearchParam() {
    if (this.selectedType !== '' ) {
      this.filterRequest = new FilterRequest();
      this.filterRequest.cedula = !this.selectedCedula ? null : this.selectedCedula;
      this.filterRequest.facultad = !this.selectedFaculty ? null : +this.selectedFaculty;
      this.filterRequest.programa = !this.selectedProgram ? null : +this.selectedProgram;
      if (this.selectedType === '') {
        this.filterRequest.tipo = 'MATERIA REGULAR';
        this.filterRequest.excluirTipo = true;
      } else {
        this.filterRequest.tipo = this.selectedType;
      }
      this.sendSearchRequest.emit(this.filterRequest);
    } else {
      // enviar mensaje de que debe seleccionar un tipo de solicitud
    }
  }

  private getFacultyList() {
    this.facultyService.getFaculty().subscribe(
      (result) => {
        if (result.data) {
            this.faculties = result.data as Faculty[];
            this.setDataAsistete();
        }
      }
    );
  }


  private getProgramList(facultad) {
    this.selectedProgram = '';
    this.programService.getProgramsList(facultad).subscribe(
      (result) => {
        if (result.data) {
          this.programs = result.data as Program[];
          this.enabledSpinner = false;
        }
      }
    );
  }

  private getProgramListBoss(facultad, cedula) {
    this.selectedProgram = '';
    this.programService.getProgramsListBoss(facultad, cedula).subscribe(
      (result) => {
        if (result.data) {
          this.programs = result.data as Program[];
          this.enabledSpinner = false;
        }
      }
    );
  }

  private getProgramListAsis(facultad, cedula) {
    this.selectedProgram = '';
    this.programService.getProgramsListAsis(facultad, cedula).subscribe(
      (result) => {
        if (result.data) {
          this.programs = result.data as Program[];
          this.enabledSpinner = false;
        }
      }
    );
  }

private setDataAsistete() {
  if (this.typeValidation > 0) {
    if (this.typeValidation  === 1) {
        if (this.currentRol.rol === this.utilityService.rolJefeDepto) {
          this.selectedFaculty = this.bossDeependence.facultadBean.codigo;
          const cedula = localStorage.getItem('cedula');
          this.getProgramListBoss(this.selectedFaculty, cedula);
        } else if (this.currentRol.rol === this.utilityService.rolUnidadAcademica) {
          this.selectedFaculty = this.bossDeependence.facultadBean.codigo;
          const cedula = localStorage.getItem('cedula');
          this.getProgramListAsis(this.selectedFaculty, cedula);
        } else {
          this.selectedFaculty = this.viceFaculty;
          this.getProgramList(this.selectedFaculty);
        }
    } else if ( this.typeValidation  === 3) {
        this.enabledFaculty = false;
    } else {
        this.enabledFaculty = false;
        this.enabledType = true;
        if (this.roles.length > 1) {
          this.enabledMateriaRegular = true;
        } else {
          this.enabledMateriaRegular = false;
          this.selectedType = 'MATERIA LENGUA EXTRANJERA';
        }
        if (this.currentRol.rol === this.utilityService.rolCoordinador) {
          this.selectedType = 'MATERIA LENGUA EXTRANJERA';
        }
    }
  } else {
    // renviar de que el usuario no tiene un rol valido
  }
}

}
